// eslint-disable-next-line no-shadow
export const enum MutationTypes {
  SET_USER = 'SET_USER'
}
export const mutations = {
  [MutationTypes.SET_USER](state, user) {
    state.user = user;
  }
};
